import { render, staticRenderFns } from "./toDoListItem.vue?vue&type=template&id=4378c0bf&"
import script from "./toDoListItem.vue?vue&type=script&lang=js&"
export * from "./toDoListItem.vue?vue&type=script&lang=js&"
import style0 from "./toDoListItem.vue?vue&type=style&index=0&id=4378c0bf&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports